import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Flex, Spinner, Text, useToast, VStack } from "@chakra-ui/react";
import PreSessionQuestionsService from "../../services/PreSessionQuestions";
import { PreSessionQuestionForm } from "./PreSessionQuestionForm";

export const EditPreSessionQuestion = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const token = localStorage.getItem("logged_in_user_token");
    const [form, setForm] = useState<any>(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!id) return;
        PreSessionQuestionsService.getById(id, token)
            .then((res: any) => {
                const data = res.data?.data;
                if (!data) {
                    throw new Error("Question not found");
                }
                setForm({
                    question_text: data.question_text || "",
                    helper_text: data.helper_text || "",
                    placeholder: data.placeholder || "",
                    input_type: data.input_type || "textarea",
                    is_required: Boolean(data.is_required),
                    is_active: data.is_active !== false,
                    options: data.options || [],
                    link: data.link || { text: "", url: "" },
                });
            })
            .catch((error: any) => {
                console.log(error);
                toast({
                    position: "top",
                    title: "Failed to load question",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
                navigate("/presession-questions");
            });
    }, [id]);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!id) return;
        setSaving(true);
        try {
            const payload = {
                ...form,
                link:
                    form.link?.text || form.link?.url
                        ? { text: form.link.text || "", url: form.link.url || "" }
                        : null,
                options: ["boolean", "mcq", "checkbox"].includes(form.input_type)
                    ? form.options
                    : [],
            };
            await PreSessionQuestionsService.update(id, payload, token);
            toast({
                position: "top",
                title: "Question updated",
                status: "success",
                duration: 1500,
                isClosable: true,
            });
            navigate("/presession-questions");
        } catch (error: any) {
            console.log(error);
            toast({
                position: "top",
                title: "Failed to update question",
                description: error?.response?.data?.message || error.message,
                status: "error",
                duration: 2500,
                isClosable: true,
            });
        } finally {
            setSaving(false);
        }
    };

    if (!form) {
        return (
            <div className="main-wrapper">
                <div className="page_title py-2">Edit Pre-session Question</div>
                <Flex justify="center" py={20} bg="#f5f7f7" minH="calc(100vh - 48px)">
                    <VStack spacing={3}>
                        <Spinner color="#327171" thickness="3px" size="lg" />
                        <Text color="gray.600">Loading question...</Text>
                    </VStack>
                </Flex>
            </div>
        );
    }

    return (
        <div className="main-wrapper">
            <div className="page_title py-2">Edit Pre-session Question</div>
            <Box p={5} bg="#f5f7f7" minH="calc(100vh - 48px)">
                <Text color="gray.600" fontSize="sm" mb={4}>
                    Changes apply to new form loads on mobile. Existing submitted answers
                    keep their stored values.
                </Text>
                <PreSessionQuestionForm
                    form={form}
                    setForm={setForm}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate("/presession-questions")}
                    saving={saving}
                    submitLabel="Save changes"
                />
            </Box>
        </div>
    );
};